module.exports = __webpack_public_path__ + "img/np_edit_3248033_000000.5748d642.svg";